/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/ai'
export default icon
